import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthAbcGuard implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> {
        return combineLatest([this.auth.isAuthenticated, this.auth.user$]).pipe(
            take(1),
            map(([isAuth, user]) => {
                if (!isAuth) return this.router.createUrlTree(['/login']);
                if (user && user.isAnonymous) return true;                         // ABC/code (anónimo)
                if (user && !user.isAnonymous) return this.router.createUrlTree(['/admin/accounts']); // admin
                return this.router.createUrlTree(['/login']);
            })
        );
    }
}
